import { PapiDeviation, PapiOriginals } from '@wix/da-papi-types';

type OriginalsFromDeviation = NonNullable<PapiDeviation['originals']>;
type OriginalsLike = OriginalsFromDeviation | PapiOriginals;
type OriginalsCompletedOrdersStream = NonNullable<PapiOriginals['completedOrders']>;

interface OriginalsCompletedOrdersNormalized {
  deviations: PapiDeviation[];
  hasMore: boolean;
  nextOffset: number | null;
  total: number;
}

function isCompletedOrdersStream(
  completedOrders:
    | OriginalsFromDeviation['completedOrders']
    | PapiOriginals['completedOrders']
    | undefined
    | null
): completedOrders is OriginalsCompletedOrdersStream {
  return Boolean(completedOrders) && !Array.isArray(completedOrders);
}

export function normalizeOriginalsCompletedOrders(
  originals?: OriginalsLike | null
): OriginalsCompletedOrdersNormalized {
  const completedOrders = originals?.completedOrders;

  if (Array.isArray(completedOrders)) {
    const total = originals?.completedOrdersCount ?? completedOrders.length;
    return {
      deviations: completedOrders,
      hasMore: total > completedOrders.length,
      nextOffset: null,
      total,
    };
  }

  if (isCompletedOrdersStream(completedOrders)) {
    const deviations = completedOrders.deviations ?? [];
    const total = originals?.completedOrdersCount ?? completedOrders.total ?? 0;
    return {
      deviations,
      hasMore: completedOrders.hasMore ?? (completedOrders.total ?? 0) > deviations.length,
      nextOffset: completedOrders.nextOffset ?? null,
      total,
    };
  }

  return {
    deviations: [],
    hasMore: false,
    nextOffset: null,
    total: originals?.completedOrdersCount ?? 0,
  };
}
